import './App.css';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { PermissionProvider } from './context/PermissionContext';
import Login from './pages/Login-page/Login';
import Register from './pages/Register-page/Register';
import Dashboard from './pages/dashboard/Dashboard';
import CustomerTable from './pages/Customer-Page/CustomerTable';
import StateMaster from './pages/State-Master/StateMaster';
import AreaMasterPage from './pages/AreaMaster-page/AreaMasterPage';
import CustomerPriceSetting from './pages/CustomerPriceSetting-Page/CustomerPriceSetting';
import Invoice from './pages/Invoice-page/Invoice';
import DocketConfirmationPage from './pages/Docket-page/DocketConfirmationPage';
import CollectionPage from './pages/Collection-page/CollectionPage';
import BranchMaster from './pages/BranchMaster-Page/BranchMaster';
import Pincode from './pages/PinCode-Page/Pincode';
import Transport from './pages/Transport-page/Transport';
import OutgoingManifest from './pages/Manifest-page/OutgoingManifest';
import IncomingManifest from './pages/Manifest-page/IncomingManifest';
import Routepage from './pages/Route-page/Routepage';
import Runsheet from './pages/Runsheet-page/Runsheet';
import UserMaster from './pages/UserMaster-page/UserMaster';
import ManifestReport from './pages/Reports/ManifestReport';
import RunsheetReport from './pages/Reports/RunsheetReport';
import WarehouseReport from './pages/Reports/WarehouseReport';
import DeliveryReport from './pages/Reports/DeliveryReport';
import MISReport from './pages/Reports/MISReport';
import MainLayout from './layouts/MainLayout';
import AddRoute from './pages/Route-page/AddRoute';
import Tracking from './pages/Tracking-page/Tracking';
import RoleMaster from './pages/RoleMaster-page/RoleMaster';
import CustomerDashboard from './pages/CustomerDashboard -page/CustomerDashboard';
import Booking from './pages/Booking -page/Booking';
import PickIn from './pages/PickIn -page/PickIn';

// ---------------------------------------------------------------------
// Simple guard – redirect to login when no token
// ---------------------------------------------------------------------
const ProtectedRoute = ({ children }) => {
  const token = localStorage.getItem('token');
  return token ? children : <Navigate to="/" replace />;
};

function App() {
  return (
    <PermissionProvider>
      <ToastContainer />
      <Router>
        <Routes>

          {/* ---------- PUBLIC ---------- */}
          <Route path="/" element={<Login />} />
          <Route path="/register" element={<Register />} />

          {/* ---------- PROTECTED (layout + auth) ---------- */}
          <Route
            path="/*"
            element={
              <ProtectedRoute>
                <MainLayout />
              </ProtectedRoute>
            }
          >
            <Route path="Dashboard" element={<Dashboard />} />
            <Route path="Customer" element={<CustomerTable />} />
            <Route path="Customer-price" element={<CustomerPriceSetting />} />
            <Route path="StateMaster" element={<StateMaster />} />
            <Route path="AreaMasterPage" element={<AreaMasterPage />} />
            <Route path="invoice" element={<Invoice />} />
            <Route path="docket" element={<DocketConfirmationPage />} />
            <Route path="collection" element={<CollectionPage />} />
            <Route path="BranchMaster" element={<BranchMaster />} />
            <Route path="Pincode" element={<Pincode />} />
            <Route path="Transport" element={<Transport />} />
            <Route path="OutgoingManifest" element={<OutgoingManifest />} />
            <Route path="IncomingManifest" element={<IncomingManifest />} />
            <Route path="Routepage" element={<Routepage />} />
            <Route path="add-route" element={<AddRoute />} />
            <Route path="Runsheet" element={<Runsheet />} />
            <Route path="UserMaster" element={<UserMaster />} />
            <Route path="ManifestReport" element={<ManifestReport />} />
            <Route path="RunsheetReport" element={<RunsheetReport />} />
            <Route path="WarehouseReport" element={<WarehouseReport />} />
            <Route path="DeliveryReport" element={<DeliveryReport />} />
            <Route path="MISReport" element={<MISReport />} />
            <Route path="Tracking" element={<Tracking />} />
            <Route path="Role" element={<RoleMaster />} />
            <Route path="customer-dashboard" element={<CustomerDashboard />} />
            <Route path='booking' element={<Booking />} />
            <Route path='pickin' element={<PickIn />} />
          </Route>
        </Routes>
      </Router>
    </PermissionProvider>
  );
}
export default App;


